import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=0b511e29&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=0b511e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b511e29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b511e29')) {
      api.createRecord('0b511e29', component.options)
    } else {
      api.reload('0b511e29', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=0b511e29&scoped=true&", function () {
      api.rerender('0b511e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/Product.vue"
export default component.exports